/**
 * Single source of truth for ScraperAPI plan features
 *
 * These are the features that ALL PAID plans include according to the product requirements.
 * This constant should be used across all billing pages (v1 and v2) to ensure consistency.
 */
export const ALL_PLAN_FEATURES = [
  "JS Rendering",
  "Premium Proxies",
  "JSON Auto Parsing",
  "Rotating Proxy Pools",
  "Custom Header Support",
  "Unlimited Bandwidth",
  "Automated Retries",
  "Desktop & Mobile User Agents",
  "99.9% Uptime Guarantee",
  "Custom Session Support",
  "CAPTCHA & Anti-Bot Detection",
  "Best-in-class Support",
] as const;

/**
 * Features that are LOCKED for free/trial users (available only on paid plans)
 * Shown in the "Upgrade to unlock" section per Figma design
 */
export const FREE_LOCKED_FEATURES = [
  "Rotating Proxy Pools",
  "Automatic Retries",
  "Premium Proxies",
  "JSON Auto Parsing",
  "Unlimited Bandwidth",
  "Custom Session Support",
  "CAPTCHA & Anti-Bot Detection",
  "JS Rendering",
] as const;

/**
 * Features that are AVAILABLE to free/trial users
 * Shown in the "Your plan's features" section per Figma design
 */
export const FREE_AVAILABLE_FEATURES = [
  "Custom Header Support",
  "99.9% Uptime Guarantee",
  "Desktop & Mobile User Agents",
  "Best-in-class Support",
] as const;

/**
 * Type for plan features
 */
export type PlanFeature = typeof ALL_PLAN_FEATURES[number];
